var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleSuperior3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 46,
    viewBox: "0 0 740 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M739 3C739 1.9107 738.084 1.00013 736.965 1.0005C594.989 1.04748 483.469 4.38382 371.697 7.72773L370.957 7.74986C258.936 11.1012 146.594 14.4528 3.03656 14.4995C1.91602 14.4999 1 15.4111 1 16.5V42.4939C1 43.5845 1.91846 44.4961 3.04034 44.4938L736.968 43.0061C738.087 43.0039 739 42.0936 739 41.0061V3Z",
    fill: "white",
    stroke: "#EBEFF6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleSuperior3);
export default __webpack_public_path__ + "static/media/rectangleSuperior3.9489fbf8368dd81597f405bb65e342a6.svg";
export { ForwardRef as ReactComponent };